module.exports = __webpack_public_path__ + "img/obsidian_destroyer.a0581934.png";